import axiosApiInstance from '@/api/shared/axios-instance';
import EstadoJugadoresComponent from '@/components/alineaciones-probables/estado-jugadores';
import Seo from '@/components/shared/custom/seo-component';
import { IsrRevalidateTime } from '@/constants/cache-state-constants';
import { LEAGUES } from '@/constants/leagues';
import { PLAYER_STATUS } from '@/constants/player-constants';
import { Pages, Rutas } from '@/constants/rutas';
import { currentSeason } from '@/constants/site';
import URL_FACTORY from '@/helpers/url-helper';

const JugadoresDudasPage = ({ playersData }) => {
    return (
        <>
            <Seo pageId={Pages.JUGADORES_DUDAS} />
            <EstadoJugadoresComponent
                status={PLAYER_STATUS.DOUBTFUL}
                title="en duda"
                selectedIndex={4}
                players={playersData} // Pasamos los datos al componente
                ruta={Rutas.JUGADORES_DUDAS}
                icon={'❓'}
            />
        </>
    );
};

export default JugadoresDudasPage;

// Función para obtener los jugadores dudosos
async function fetchPlayersByStatus(status) {
    const response = await axiosApiInstance.post(URL_FACTORY.GetPlayersByStatus, {
        league: LEAGUES.LA_LIGA,
        season: currentSeason,
        status,
    });
    return response.data?.players || [];
}

// Añadimos la función getStaticProps para implementar ISR
export async function getStaticProps() {
    try {
        const playersData = await fetchPlayersByStatus(PLAYER_STATUS.DOUBTFUL);
        return {
            props: {
                playersData,
            },
            revalidate: IsrRevalidateTime.JUGADORES_DUDAS, // Asegúrate de que esta constante esté definida correctamente
        };
    } catch (_error) {
        console.error('Error in getStaticProps:', _error);
        return {
            notFound: true, // Devuelve un 404 si hay algún problema
        };
    }
}
